import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ContentProvider } from "@/contexts/ContentContext";
import { BrandingProvider } from "@/contexts/BrandingContext";
import LandingPage from "@/pages/LandingPage";
import DashboardPage from "@/pages/DashboardPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import TreeMonitorPage from "@/pages/TreeMonitorPage";
import SocialPage from "@/pages/SocialPage";
import AdminPage from "@/pages/AdminPage";
import DataCenterPage from "@/pages/DataCenterPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ApiDocsPage from "@/pages/ApiDocsPage";
import CarbonHubPage from "@/pages/CarbonHubPage";
import DeveloperPage from "@/pages/DeveloperPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import VerifyPage from "@/pages/VerifyPage";
import CmsPage from "@/pages/CmsPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-stone-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-stone-600 border-t-emerald-400 rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <BrandingProvider>
            <div className="App" data-testid="app-root">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/api-docs" element={<ApiDocsPage />} />
              <Route path="/carbon-hub" element={<CarbonHubPage />} />
              <Route path="/developer" element={<DeveloperPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/verify" element={<VerifyPage />} />
              {/* Public CMS pages */}
              <Route path="/features" element={<CmsPage slug="features" />} />
              <Route path="/live-data" element={<CmsPage slug="live-data" />} />
              <Route path="/about" element={<CmsPage slug="about" />} />
              <Route path="/research-papers" element={<CmsPage slug="research-papers" />} />
              <Route path="/methodology" element={<CmsPage slug="methodology" />} />
              <Route path="/data-sources" element={<CmsPage slug="data-sources" />} />
              <Route path="/contact-us" element={<CmsPage slug="contact-us" />} />
              <Route path="/newsletter" element={<CmsPage slug="newsletter" />} />
              <Route path="/partnerships" element={<CmsPage slug="partnerships" />} />
              <Route path="/careers" element={<CmsPage slug="careers" />} />
              <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/trees" element={<ProtectedRoute><TreeMonitorPage /></ProtectedRoute>} />
              {/* Legacy routes — merged into Carbon Hub */}
              <Route path="/carbon" element={<Navigate to="/carbon-hub" replace />} />
              <Route path="/marketplace" element={<Navigate to="/carbon-hub" replace />} />
              <Route path="/carbon-registry" element={<Navigate to="/carbon-hub" replace />} />
              <Route path="/social" element={<ProtectedRoute><SocialPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
              <Route path="/data-center" element={<ProtectedRoute><DataCenterPage /></ProtectedRoute>} />
            </Routes>
            </div>
          </BrandingProvider>
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
